import { css } from 'styled-components';

export const ArchivoFont = css`
    font-family: 'Archivo Black';
`;

export const CaprasimoFont = css`
    font-family: 'Caprasimo';
`;

export const VollkornFont = css`
    font-family: 'Vollkorn';
`;

export const Garamond = css`
    font-family: 'EB Garamond';
`

export const Cormorant = css`
    font-family: 'Cormorant';
`
